import React from 'react';

const STATUS_CONFIG = {
  DRAFT: {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    label: 'Rascunho'
  },
  PENDING: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-700',
    label: 'Pendente'
  },
  GENERATED: {
    bg: 'bg-blue-100',
    text: 'text-blue-700',
    label: 'Gerado'
  },
  APPROVED: {
    bg: 'bg-green-100',
    text: 'text-green-700',
    label: 'Aprovado'
  },
  IN_PRODUCTION: {
    bg: 'bg-purple-100',
    text: 'text-purple-700',
    label: 'Em Produção'
  },
  COMPLETED: {
    bg: 'bg-emerald-100',
    text: 'text-emerald-700',
    label: 'Concluído'
  },
  CANCELLED: {
    bg: 'bg-red-100',
    text: 'text-red-700',
    label: 'Cancelado'
  }
};

const CuttingPlanStatusBadge = ({ status, size = 'md' }) => {
  const config = STATUS_CONFIG[status] || {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    label: status
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base'
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${config.bg} ${config.text} ${sizeClasses[size]}`}
    >
      {config.label}
    </span>
  );
};

export default CuttingPlanStatusBadge;
